module.exports = __webpack_public_path__ + "static/media/three-white-dots.a6e2d4ac.svg";